<template>
  <div>
    <div v-if="foundItems !== undefined">
      <form class="a-sort" action="">
        <p class="a-sort__see">
          Результат: {{foundItems}} пользователя
        </p>
        <div class="a-sort__block-sort">
          <div class="a-sort__left-block">
            <div class="a-sort__label">Сортировать:</div>
            <dropdown-new class="a-sort__select" v-model="order" @change="onOrderChange">
              <option :value="enums.SortOrder.EMPTY">По умолчанию</option>
              <option :value="enums.SortOrder.ASCENDING">По дате регистрации ↑</option>
              <option :value="enums.SortOrder.DESCENDING">По дате регистрации ↓</option>
            </dropdown-new>
          </div>
          <div class="a-sort__right-block">
            <button class="gui-btn gui-btn--red gui-btn--w-247" type="button">Добавить пользователя</button>
            <button class="gui-btn gui-btn--red gui-btn--w-140" type="button" @click="exportUsersList">Экспорт</button>
          </div>
        </div>
      </form>

      <div class="a-container-form">
        <div class="table-tab__container" tabindex="1" style="overflow: hidden; outline: none;">
          <table class="table-tab__block table " style="width: 1200px">
            <thead class="table-tab__thead">
            <tr class="table-tab__height-auto-column-header" style="height: 48px;">
              <th>ФИО</th>
              <th>Статус</th>
              <th>Главный пользователь</th>
              <th>Член комиссии</th>
              <td></td>
            </tr>
            </thead>
            <tbody class="table-tab__tbody">
            <tr class="table-tab__height-auto-column-body table-tab__tr-border" v-for="(person, rowId) in items">
              <td>
                <router-link class="table-tab__color u-text-underline"
                             :to="{name: $route.meta.details, params: { userId: person.id, tab: 'account'}}">
                  {{person | fullName}}
                </router-link>
              </td>

              <td>
                <template v-if="editable && editable.row === rowId">
                  <dropdown-new class="select-w-280"
                                v-model="editable.values.role"
                                @change="onRoleChanged(person)">
                    <option :value="enums.UserRole.COMMISSION_MEMBER_NONE">Не установлена</option>
                    <option :value="enums.UserRole.ORGANIZER" v-t="'user-role.organizer'"></option>
                    <option :value="enums.UserRole.MAIN_ORGANIZER" v-t="'user-role.main-organizer'"></option>
                  </dropdown-new>
                </template>
                <template v-else>
                  {{$t(person.role.label)}}
                </template>
              </td>

              <td>
                <template v-if="editable && editable.row === rowId">
                  <div class="a-form-field"
                       :class="{ 'a-input-group--error': $v.editable.$invalid }"
                       v-if="canChangeOwner">
                    <user-search class="select-w-280"
                                 main-organizer
                                 :placeholder="$t('form.user-search.registration-date.user.placeholder')"
                                 v-model="editable.values.owner">
                    </user-search>
                  </div>
                  <div class="a-form-field"
                       :class="{ 'a-input-group--error': $v.editable.$invalid }"
                       v-else-if="canChangeOwnerOfSubordinates">
                    <user-search class="select-w-280"
                                 main-organizer
                                 :placeholder="$t('form.user-search.registration-date.user.placeholder')"
                                 v-model="editable.values.subordinatesOwner">
                    </user-search>
                  </div>
                </template>
                <template v-else>
                  {{person.parentLastName}} {{person.parentFirstName}} {{person.parentMiddleName}}
                </template>
              </td>

              <td>
                <template v-if="editable && editable.row === rowId">
                  <div class="a-checkbox">
                    <label class="a-checkbox__label">
                      <input class="a-checkbox__input"
                             type="checkbox"
                             v-model="editable.values.inCommission">
                      <span class="a-checkbox__icon"></span>
                      <span class="a-checkbox__text"></span>
                    </label>
                  </div>
                </template>
                <template v-else>
                  <div class="a-checkbox">
                    <label class="a-checkbox__label a-checkbox__label--disable">
                      <input class="a-checkbox__input"
                             type="checkbox" disabled
                             v-model="person.inCommission">
                      <span class="a-checkbox__icon"></span>
                      <span class="a-checkbox__text"></span>
                    </label>
                  </div>
                </template>
              </td>

              <td class="table-tab__actions">
                <div class="table-tab__actions">
                  <template v-if="!editable || editable.row !== rowId">
                    <button type="button"
                            :title="$t('buttons.modify')"
                            :disabled="editable && editable.row !== rowId"
                            @click="onEditItemClick(rowId, person)">
                      <img class="table-tab__img-1" src="@/assets/img/static/b-icon_edit.svg" alt="">
                    </button>
                  </template>
                  <template v-else>
                    <button type="button" @click="onSaveChangesClick" :title="$t('buttons.save')">
                      <img class="table-tab__img-4" src="@/assets/img/static/tab-ok.svg" alt="">
                    </button>
                    <button type="button" @click="onDiscardChangesClick" :title="$t('buttons.cancel')">
                      <img class="table-tab__img-5" src="@/assets/img/static/tab-close.svg" alt="">
                    </button>
                  </template>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <button class="gui-btn gui-btn--more u-margin-24-auto"
              type="button"
              @click="fetchMoreUsers"
              v-if="foundItems !== items.length">
        {{$t('buttons.show-more')}}
      </button>
    </div>

    <template v-if="permissions.CAN_INVITE_USER">
      <div class="contractor__add-user" >
        <h2>Пригласить пользователя:</h2>
      </div>

      <div class="contractor__container-edit">
        <div class="a-container-form contractor__block">
          <div class="a-input-group a-input-group--contractor">
            <p class="a-label a-label--w-130">{{$t('labels.email')}}:</p>
            <div class="a-input-group__prepend ">@</div>
            <input type="email"
                   placeholder="Email"
                   class="select-w-280"
                   v-model="invite.email">
          </div>
        </div>

        <div class="personal-data__btn-block">
          <button class="gui-btn gui-btn--red gui-btn--w-370" @click.prevent="onInviteUserClick('main')">Пригласить Главного организатора</button>
          <button class="gui-btn gui-btn--red gui-btn--w-370" @click.prevent="onInviteUserClick('commission')">Пригласить в Комиссию</button>
        </div>
      </div>

      <modal v-if="showInviteSent">
        <template v-slot:header>
          <h5 class="modal-title">{{$t('form.contractor.invitation.title')}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="showInviteSent = false">
            <span aria-hidden="true"><img src="@/assets/img/static/b-icon_close_x.svg" alt=""></span>
          </button>
        </template>

        <template v-slot:body>
          <div class="modal-body__registration">
            <p v-if="invite.error">{{$t(invite.error)}}</p>
            <p v-else>{{$t('form.contractor.invitation.body')}}</p>
          </div>
        </template>

        <template v-slot:footer>
          <button class="gui-btn gui-btn--white-border" @click.prevent="showInviteSent = false" v-t="'buttons.next'"></button>
        </template>
      </modal>
    </template>
  </div>
</template>

<script>
  import UserSearch from '@/components/common/inputs/UserSearch'

  export default {
    components: {
      UserSearch
    },

    data: () => ({
      order: undefined,
      editable: undefined,
      invite: {
        email: undefined,
        error: undefined
      },
      showInviteSent: false
    }),

    computed: {
      foundItems() { return this.$store.state.search.users.total },

      items() { return this.$store.state.search.users.items },

      permissions() {
        return this.$store.getters.currentUser.permissions;
      },
      canChangeOwner() {
        const role = _.get(this.editable, 'values.role');
        return role.valueOf() !== this.enums.UserRole.MAIN_ORGANIZER;
      },

      canChangeOwnerOfSubordinates() {
        const role = _.get(this.editable, 'values.role');
        return role.valueOf() !== this.enums.UserRole.MAIN_ORGANIZER
          && role.valueOf() === this.enums.UserRole.MAIN_ORGANIZER;
      },
    },

    validations: {
      editable: {
        validMainUser: function(editable) {
          return editable.values.role
        }
      }
    },

    methods: {
      exportUsersList() {
        this.$store.dispatch('exportUsersList');
      },

      fetchMoreUsers() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('fetchMoreUsers');
          }
          catch(e) {
            console.error('unable to fetch more users', e);
          }
        });
      },

      onOrderChange() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('fetchSortedUsers', { order: this.order });
          }
          catch(e) {
            console.error('unable to fetch sorted users list', e);
          }
        });
      },

      onEditItemClick(rowId, item) {
        this.editable = {
          row: rowId,
          values: {
            userId: item.id,
            owner: {
              id: item.parentId,
              name: [item.parentLastName, item.parentFirstName, item.parentMiddleName].join(' ')
            },
            subordinatesOwner: undefined,
            role: item.role,
            inCommission: item.inCommission
          }
        };
      },

      onSaveChangesClick() {
        //this.$v.$touch();
        //if (this.$v.$invalid) return;

        let owner = 0;

        if (this.editable.values.role.valueOf() === this.enums.UserRole.MAIN_ORGANIZER) {
          owner = this.editable.values.userId;
        }
        else if (this.canChangeOwnerOfSubordinates) {
          owner = this.editable.values.subordinatesOwner.id;
        }
        else if (this.canChangeOwner) {
          owner = this.editable.values.owner.id;
        }

        return this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('changeCustomerUserInfo', {
              userId: this.editable.values.userId,
              role: this.editable.values.role.valueOf(),
              mainUserId: owner,
              inCommission: !!this.editable.values.inCommission
            });
            this.editable = undefined;
            await this.$store.dispatch('fetchUsersRefresh');
          }
          catch(e) {
            this.globalErrorHandler(e);
            console.error('unable to fetch sorted users list', e);
          }
        });
      },

      onDiscardChangesClick() {
        this.editable = undefined;
      },

      async onInviteUserClick(role) {
        this.invite.error = undefined;

        this.runAction(async () => {
          try {
            await this.$store.dispatch('sendInvite', {
              email: this.invite.email,
              role: role
            });

            this.invite.email = undefined;
          }
          catch(e) {
            console.error('Unable to send invite due to unexpected error', e);

            this.invite.error = 'errors.unknown';

            if (e == api.Errors.EMAIL_BUSY) {
              this.invite.error = 'errors.email-busy';
            }
          }

          this.showInviteSent = true;
        });
      },

      onRoleChanged(person) {
        if (this.editable.values.role.valueOf() === this.enums.UserRole.MAIN_ORGANIZER) {
          this.editable.values.mainUser = {
            id: person.id,
            name: [person.lastName, person.firstName, person.middleName].join(' ')
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
